export default (b64, descriptor) => {
    const newlined = (b64.match(/.{1,64}/g) || []).join('\n');
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};



// WEBPACK FOOTER //
// ./~/jose/dist/browser/lib/format_pem.js